import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IAge from '../../interfaces/IAge'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { ageList } from '../../services/api'

interface AgeContextState extends BaseContextState {
  ages: Array<IAge> | null
}

export interface AgeContextData extends AgeContextState {
  resetErrors: Function,
  requestAgeList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as AgeContextData)

// Export consumer
export const AgeConsumer = Consumer

export class AgeProvider extends BaseContextProvider {
  state: AgeContextState = {
    ages: null
  }

  /**
   * Make api request for age list
   * 
   * @param {SearchRequest} payload 
   */
  requestAgeList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await ageList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'ages'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestAgeList: this.requestAgeList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
